import { createFileRoute } from '@tanstack/react-router'
import { ProductDetailPage } from '@/components/engineering/ProductPages'
import {
  productPageHead,
  jsonLd,
  softwareApplicationLd,
  seoStrings,
} from '@/lib/seo-head'
import { LINKS } from '@/lib/company'
export const Route = createFileRoute('/{-$locale}/products_/arkived')({
  head: ({ params }) => {
    const head = productPageHead('arkived', params.locale)
    return {
      ...head,
      scripts: [
        ...head.scripts,
        jsonLd(
          softwareApplicationLd({
            name: 'arkived',
            url: LINKS.arkived,
            codeRepository: LINKS.arkivedRepo,
            description: seoStrings('arkived', params.locale).description,
          }),
        ),
      ],
    }
  },
  component: () => <ProductDetailPage />,
})
